export const merchantOnboardingTranslations = {
  en: {
    'merchantOnboarding.businessNameRequired': 'Business name is required',
    'merchantOnboarding.businessTypeRequired': 'Business type is required',
    'merchantOnboarding.emailRequired': 'Email is required',
    'merchantOnboarding.phoneRequired': 'Phone number is required',
    'merchantOnboarding.streetRequired': 'Street address is required',
    'merchantOnboarding.cityRequired': 'City is required',
    'merchantOnboarding.stateRequired': 'State is required',
    'merchantOnboarding.zipCodeRequired': 'ZIP code is required',
    'merchantOnboarding.stripeIdRequired': 'Stripe Connect ID is required',
    'merchantOnboarding.stripeIdFormat': 'Stripe Connect ID must start with "acct_"',
    'merchantOnboarding.stripeVerificationFailed': 'Verification failed',
    'merchantOnboarding.accountLimited': 'Account Limited',
    'merchantOnboarding.accountLimitedDesc': 'Your Stripe account cannot accept charges yet. Please complete Stripe requirements.',
    'merchantOnboarding.stripeConnectedLimited': 'Stripe Connected (Limited)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Your account can accept payments but cannot receive payouts yet. Check Stripe for requirements.',
    'merchantOnboarding.stripeConnected': 'Stripe Connected',
    'merchantOnboarding.stripeConnectedDesc': 'Account verified! You can accept {currency} payments in {country}.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'The Stripe Connect ID is not valid or could not be verified.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'Unable to verify your Stripe Connect ID. Please check and try again.',
    'merchantOnboarding.setupComplete': 'Setup Complete!',
    'merchantOnboarding.setupCompleteDesc': 'Your merchant account has been set up successfully.',
    'merchantOnboarding.setupFailed': 'Setup Failed',
    'merchantOnboarding.setupFailedDesc': 'Unable to complete merchant setup. Please try again.',
    'merchantOnboarding.error': 'Merchant setup error',
    'merchantOnboarding.stripeConnect': 'Stripe Connect',
    'merchantOnboarding.stripeConnectDesc': 'Stripe account connected successfully',
    'merchantOnboarding.stripeConnectFailed': 'Unable to connect Stripe account',
    'merchantOnboarding.step1.title': 'Business Information',
    'merchantOnboarding.step1.subtitle': 'Tell us about your business',
    'merchantOnboarding.step1.businessName': 'Business Name',
    'merchantOnboarding.step1.businessNamePlaceholder': 'Your Business Name',
    'merchantOnboarding.step1.businessType': 'Business Type',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Select business type',
    'merchantOnboarding.step1.retail': 'Retail Store',
    'merchantOnboarding.step1.restaurant': 'Restaurant',
    'merchantOnboarding.step1.service': 'Service Provider',
    'merchantOnboarding.step1.online': 'Online Business',
    'merchantOnboarding.step1.wholesale': 'Wholesale',
    'merchantOnboarding.step1.other': 'Other',
    'merchantOnboarding.step1.email': 'Business Email',
    'merchantOnboarding.step1.emailPlaceholder': 'business@example.com',
    'merchantOnboarding.step1.phone': 'Phone Number',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Website (Optional)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://yourbusiness.com',
    'merchantOnboarding.step1.logo': 'Logo URL (Optional)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://yourbusiness.com/logo.png',
    'merchantOnboarding.step1.description': 'Business Description',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Tell customers what your business offers...',
    'merchantOnboarding.step2.title': 'Business Location',
    'merchantOnboarding.step2.subtitle': 'Where is your business located?',
    'merchantOnboarding.step2.street': 'Street Address',
    'merchantOnboarding.step2.streetPlaceholder': '123 Main Street',
    'merchantOnboarding.step2.city': 'City',
    'merchantOnboarding.step2.cityPlaceholder': 'New York',
    'merchantOnboarding.step2.state': 'State',
    'merchantOnboarding.step2.statePlaceholder': 'NY',
    'merchantOnboarding.step2.zip': 'ZIP Code',
    'merchantOnboarding.step2.zipPlaceholder': '10001',
    'merchantOnboarding.step2.country': 'Country',
    'merchantOnboarding.step2.US': 'United States',
    'merchantOnboarding.step2.CA': 'Canada',
    'merchantOnboarding.step2.MX': 'Mexico',
    'merchantOnboarding.step2.GB': 'United Kingdom',
    'merchantOnboarding.step2.addressHint': 'Your business address will be visible to customers and used for local search results.',
    'merchantOnboarding.step3.title': 'Payment Setup',
    'merchantOnboarding.step3.subtitle': 'Connect your Stripe account to accept payments',
    'merchantOnboarding.step3.processingSetup': 'Payment Processing Setup',
    'merchantOnboarding.step3.processingSetupDesc': 'Connect your Stripe account to receive payments from customers (required by banking regulations)',
    'merchantOnboarding.step3.stripeId': 'Payment Processor Account ID (Stripe Connect)',
    'merchantOnboarding.step3.stripeIdHint': 'Required to receive funds',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'Verified',
    'merchantOnboarding.step3.verifying': 'Verifying...',
    'merchantOnboarding.step3.verify': 'Verify',
    'merchantOnboarding.step3.whyRequired': 'Why is this required?',
    'merchantOnboarding.step3.whyRequiredDesc': 'Banking regulations require verified payment processing for all merchants.',
    'merchantOnboarding.step3.noAccount': "Don't have an account?",
    'merchantOnboarding.step3.createStripe': 'Create a Stripe Connect account',
    'merchantOnboarding.step3.quickActions': 'Quick Actions:',
    'merchantOnboarding.step3.createNewAccount': 'Create New Account',
    'merchantOnboarding.step3.findMyId': 'Find My Account ID',
    'merchantOnboarding.step3.whereToFindId': 'Where to find your ID:',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Stripe Dashboard → Settings → Connect Settings → Your account ID starts with "acct_"',
    'merchantOnboarding.step3.setupComplete': 'Your payment processing is set up! You can now receive payments from customers.',
    'merchantOnboarding.step3.paymentSettings': 'Payment Settings',
    'merchantOnboarding.step3.acceptOnline': 'Accept Online Payments',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Allow customers to pay online',
    'merchantOnboarding.step3.acceptInStore': 'Accept In-Store Payments',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Accept payments at physical location',
    'merchantOnboarding.step4.title': "You're All Set!",
    'merchantOnboarding.step4.subtitle': 'Your merchant account is ready',
    'merchantOnboarding.step4.infoConfigured': 'Business information configured',
    'merchantOnboarding.step4.locationAdded': 'Location added',
    'merchantOnboarding.step4.paymentReady': 'Payment processing ready',
    'merchantOnboarding.step4.tourTitle': 'Would you like a tour?',
    'merchantOnboarding.step4.tourDesc': 'Get familiar with your seller tools and features',
    'merchantOnboarding.step4.showTour': 'Show me around the seller tools',
    'merchantOnboarding.step4.tourDuration': '5-minute interactive tour',
    'merchantOnboarding.step4.tourHint': 'You can always access the tour later from your merchant dashboard.',
    'merchantOnboarding.header': 'Merchant Setup',
    'merchantOnboarding.step': 'Step',
    'merchantOnboarding.back': 'Back',
    'merchantOnboarding.next': 'Next',
    'merchantOnboarding.completingSetup': 'Completing Setup...',
    'merchantOnboarding.completeSetup': 'Complete Setup',
  },
  es: {
    'merchantOnboarding.businessNameRequired': 'El nombre del negocio es obligatorio',
    'merchantOnboarding.businessTypeRequired': 'El tipo de negocio es obligatorio',
    'merchantOnboarding.emailRequired': 'El correo electrónico es obligatorio',
    'merchantOnboarding.phoneRequired': 'El número de teléfono es obligatorio',
    'merchantOnboarding.streetRequired': 'La dirección es obligatoria',
    'merchantOnboarding.cityRequired': 'La ciudad es obligatoria',
    'merchantOnboarding.stateRequired': 'El estado es obligatorio',
    'merchantOnboarding.zipCodeRequired': 'El código postal es obligatorio',
    'merchantOnboarding.stripeIdRequired': 'El ID de Stripe Connect es obligatorio',
    'merchantOnboarding.stripeIdFormat': 'El ID de Stripe Connect debe comenzar con "acct_"',
    'merchantOnboarding.stripeVerificationFailed': 'La verificación falló',
    'merchantOnboarding.accountLimited': 'Cuenta Limitada',
    'merchantOnboarding.accountLimitedDesc': 'Tu cuenta de Stripe aún no puede aceptar cargos. Por favor, completa los requisitos de Stripe.',
    'merchantOnboarding.stripeConnectedLimited': 'Stripe Conectado (Limitado)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Tu cuenta puede aceptar pagos pero aún no puede recibir transferencias. Consulta Stripe para los requisitos.',
    'merchantOnboarding.stripeConnected': 'Stripe Conectado',
    'merchantOnboarding.stripeConnectedDesc': '¡Cuenta verificada! Puedes aceptar pagos en {currency} en {country}.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'El ID de Stripe Connect no es válido o no pudo ser verificado.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'No se pudo verificar tu ID de Stripe Connect. Por favor, compruébalo y vuelve a intentarlo.',
    'merchantOnboarding.setupComplete': '¡Configuración Completa!',
    'merchantOnboarding.setupCompleteDesc': 'Tu cuenta de comerciante ha sido configurada exitosamente.',
    'merchantOnboarding.setupFailed': 'La Configuración Falló',
    'merchantOnboarding.setupFailedDesc': 'No se pudo completar la configuración del comerciante. Por favor, inténtalo de nuevo.',
    'merchantOnboarding.step1.title': 'Información del Negocio',
    'merchantOnboarding.step1.subtitle': 'Cuéntanos sobre tu negocio',
    'merchantOnboarding.step1.businessName': 'Nombre del Negocio',
    'merchantOnboarding.step1.businessNamePlaceholder': 'El Nombre de tu Negocio',
    'merchantOnboarding.step1.businessType': 'Tipo de Negocio',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Selecciona el tipo de negocio',
    'merchantOnboarding.step1.retail': 'Tienda Minorista',
    'merchantOnboarding.step1.restaurant': 'Restaurante',
    'merchantOnboarding.step1.service': 'Proveedor de Servicios',
    'merchantOnboarding.step1.online': 'Negocio en Línea',
    'merchantOnboarding.step1.wholesale': 'Venta al por Mayor',
    'merchantOnboarding.step1.other': 'Otro',
    'merchantOnboarding.step1.email': 'Correo Electrónico del Negocio',
    'merchantOnboarding.step1.emailPlaceholder': 'negocio@ejemplo.com',
    'merchantOnboarding.step1.phone': 'Número de Teléfono',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Sitio Web (Opcional)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://tunegocio.com',
    'merchantOnboarding.step1.logo': 'URL del Logo (Opcional)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://tunegocio.com/logo.png',
    'merchantOnboarding.step1.description': 'Descripción del Negocio',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Cuéntales a los clientes qué ofrece tu negocio...',
    'merchantOnboarding.step2.title': 'Ubicación del Negocio',
    'merchantOnboarding.step2.subtitle': '¿Dónde se encuentra tu negocio?',
    'merchantOnboarding.step2.street': 'Dirección',
    'merchantOnboarding.step2.streetPlaceholder': '123 Calle Principal',
    'merchantOnboarding.step2.city': 'Ciudad',
    'merchantOnboarding.step2.cityPlaceholder': 'Nueva York',
    'merchantOnboarding.step2.state': 'Estado',
    'merchantOnboarding.step2.statePlaceholder': 'NY',
    'merchantOnboarding.step2.zip': 'Código Postal',
    'merchantOnboarding.step2.zipPlaceholder': '10001',
    'merchantOnboarding.step2.country': 'País',
    'merchantOnboarding.step2.US': 'Estados Unidos',
    'merchantOnboarding.step2.CA': 'Canadá',
    'merchantOnboarding.step2.MX': 'México',
    'merchantOnboarding.step2.GB': 'Reino Unido',
    'merchantOnboarding.step2.addressHint': 'La dirección de tu negocio será visible para los clientes y se usará para los resultados de búsqueda locales.',
    'merchantOnboarding.step3.title': 'Configuración de Pagos',
    'merchantOnboarding.step3.subtitle': 'Conecta tu cuenta de Stripe para aceptar pagos',
    'merchantOnboarding.step3.processingSetup': 'Configuración del Procesamiento de Pagos',
    'merchantOnboarding.step3.processingSetupDesc': 'Conecta tu cuenta de Stripe para recibir pagos de los clientes (requerido por las regulaciones bancarias)',
    'merchantOnboarding.step3.stripeId': 'ID de Cuenta del Procesador de Pagos (Stripe Connect)',
    'merchantOnboarding.step3.stripeIdHint': 'Requerido para recibir fondos',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'Verificado',
    'merchantOnboarding.step3.verifying': 'Verificando...',
    'merchantOnboarding.step3.verify': 'Verificar',
    'merchantOnboarding.step3.whyRequired': '¿Por qué es esto obligatorio?',
    'merchantOnboarding.step3.whyRequiredDesc': 'Las regulaciones bancarias requieren un procesamiento de pagos verificado para todos los comerciantes.',
    'merchantOnboarding.step3.noAccount': '¿No tienes una cuenta?',
    'merchantOnboarding.step3.createStripe': 'Crear una cuenta de Stripe Connect',
    'merchantOnboarding.step3.quickActions': 'Acciones Rápidas:',
    'merchantOnboarding.step3.createNewAccount': 'Crear Nueva Cuenta',
    'merchantOnboarding.step3.findMyId': 'Encontrar Mi ID de Cuenta',
    'merchantOnboarding.step3.whereToFindId': 'Dónde encontrar tu ID:',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Panel de Stripe → Configuración → Configuración de Connect → Tu ID de cuenta comienza con "acct_"',
    'merchantOnboarding.step3.setupComplete': '¡La configuración de tu procesamiento de pagos está lista! Ahora puedes recibir pagos de los clientes.',
    'merchantOnboarding.step3.paymentSettings': 'Configuración de Pagos',
    'merchantOnboarding.step3.acceptOnline': 'Aceptar Pagos en Línea',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Permitir que los clientes paguen en línea',
    'merchantOnboarding.step3.acceptInStore': 'Aceptar Pagos en Tienda',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Aceptar pagos en una ubicación física',
    'merchantOnboarding.step4.title': '¡Todo Listo!',
    'merchantOnboarding.step4.subtitle': 'Tu cuenta de comerciante está lista',
    'merchantOnboarding.step4.infoConfigured': 'Información del negocio configurada',
    'merchantOnboarding.step4.locationAdded': 'Ubicación añadida',
    'merchantOnboarding.step4.paymentReady': 'Procesamiento de pagos listo',
    'merchantOnboarding.step4.tourTitle': '¿Te gustaría un tour?',
    'merchantOnboarding.step4.tourDesc': 'Familiarízate con tus herramientas y funciones de vendedor',
    'merchantOnboarding.step4.showTour': 'Muéstrame las herramientas de vendedor',
    'merchantOnboarding.step4.tourDuration': 'Tour interactivo de 5 minutos',
    'merchantOnboarding.step4.tourHint': 'Siempre puedes acceder al tour más tarde desde tu panel de comerciante.',
    'merchantOnboarding.header': 'Configuración de Comerciante',
    'merchantOnboarding.step': 'Paso',
    'merchantOnboarding.back': 'Atrás',
    'merchantOnboarding.next': 'Siguiente',
    'merchantOnboarding.completingSetup': 'Completando Configuración...',
    'merchantOnboarding.completeSetup': 'Completar Configuración',
  },
  fr: {
    'merchantOnboarding.businessNameRequired': 'Le nom de l\'entreprise est requis',
    'merchantOnboarding.businessTypeRequired': 'Le type d\'entreprise est requis',
    'merchantOnboarding.emailRequired': 'L\'e-mail est requis',
    'merchantOnboarding.phoneRequired': 'Le numéro de téléphone est requis',
    'merchantOnboarding.streetRequired': 'L\'adresse est requise',
    'merchantOnboarding.cityRequired': 'La ville est requise',
    'merchantOnboarding.stateRequired': 'L\'état est requis',
    'merchantOnboarding.zipCodeRequired': 'Le code postal est requis',
    'merchantOnboarding.stripeIdRequired': 'L\'ID Stripe Connect est requis',
    'merchantOnboarding.stripeIdFormat': 'L\'ID Stripe Connect doit commencer par "acct_"',
    'merchantOnboarding.stripeVerificationFailed': 'La vérification a échoué',
    'merchantOnboarding.accountLimited': 'Compte limité',
    'merchantOnboarding.accountLimitedDesc': 'Votre compte Stripe ne peut pas encore accepter de charges. Veuillez compléter les exigences Stripe.',
    'merchantOnboarding.stripeConnectedLimited': 'Stripe connecté (limité)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Votre compte peut accepter les paiements mais ne peut pas encore recevoir de paiements. Vérifiez Stripe pour les exigences.',
    'merchantOnboarding.stripeConnected': 'Stripe connecté',
    'merchantOnboarding.stripeConnectedDesc': 'Compte vérifié ! Vous pouvez accepter les paiements en {currency} en {country}.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'L\'ID Stripe Connect n\'est pas valide ou n\'a pas pu être vérifié.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'Impossible de vérifier votre ID Stripe Connect. Veuillez vérifier et réessayer.',
    'merchantOnboarding.setupComplete': 'Configuration terminée !',
    'merchantOnboarding.setupCompleteDesc': 'Votre compte marchand a été configuré avec succès.',
    'merchantOnboarding.setupFailed': 'Échec de la configuration',
    'merchantOnboarding.setupFailedDesc': 'Impossible de terminer la configuration du marchand. Veuillez réessayer.',
    'merchantOnboarding.step1.title': 'Informations sur l\'entreprise',
    'merchantOnboarding.step1.subtitle': 'Parlez-nous de votre entreprise',
    'merchantOnboarding.step1.businessName': 'Nom de l\'entreprise',
    'merchantOnboarding.step1.businessNamePlaceholder': 'Le nom de votre entreprise',
    'merchantOnboarding.step1.businessType': 'Type d\'entreprise',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Sélectionnez le type d\'entreprise',
    'merchantOnboarding.step1.retail': 'Magasin de détail',
    'merchantOnboarding.step1.restaurant': 'Restaurant',
    'merchantOnboarding.step1.service': 'Prestataire de services',
    'merchantOnboarding.step1.online': 'Entreprise en ligne',
    'merchantOnboarding.step1.wholesale': 'Vente en gros',
    'merchantOnboarding.step1.other': 'Autre',
    'merchantOnboarding.step1.email': 'E-mail professionnel',
    'merchantOnboarding.step1.emailPlaceholder': 'entreprise@exemple.com',
    'merchantOnboarding.step1.phone': 'Numéro de téléphone',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Site Web (Optionnel)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://votreentreprise.com',
    'merchantOnboarding.step1.logo': 'URL du logo (Optionnel)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://votreentreprise.com/logo.png',
    'merchantOnboarding.step1.description': 'Description de l\'entreprise',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Dites aux clients ce que votre entreprise offre...',
    'merchantOnboarding.step2.title': 'Localisation de l\'entreprise',
    'merchantOnboarding.step2.subtitle': 'Où se trouve votre entreprise ?',
    'merchantOnboarding.step2.street': 'Adresse',
    'merchantOnboarding.step2.streetPlaceholder': '123 Rue Principale',
    'merchantOnboarding.step2.city': 'Ville',
    'merchantOnboarding.step2.cityPlaceholder': 'New York',
    'merchantOnboarding.step2.state': 'État',
    'merchantOnboarding.step2.statePlaceholder': 'NY',
    'merchantOnboarding.step2.zip': 'Code postal',
    'merchantOnboarding.step2.zipPlaceholder': '10001',
    'merchantOnboarding.step2.country': 'Pays',
    'merchantOnboarding.step2.US': 'États-Unis',
    'merchantOnboarding.step2.CA': 'Canada',
    'merchantOnboarding.step2.MX': 'Mexique',
    'merchantOnboarding.step2.GB': 'Royaume-Uni',
    'merchantOnboarding.step2.addressHint': 'L\'adresse de votre entreprise sera visible pour les clients et utilisée pour les résultats de recherche locale.',
    'merchantOnboarding.step3.title': 'Configuration des paiements',
    'merchantOnboarding.step3.subtitle': 'Connectez votre compte Stripe pour accepter les paiements',
    'merchantOnboarding.step3.processingSetup': 'Configuration du traitement des paiements',
    'merchantOnboarding.step3.processingSetupDesc': 'Connectez votre compte Stripe pour recevoir les paiements des clients (requis par les réglementations bancaires)',
    'merchantOnboarding.step3.stripeId': 'ID de compte du processeur de paiement (Stripe Connect)',
    'merchantOnboarding.step3.stripeIdHint': 'Requis pour recevoir des fonds',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'Vérifié',
    'merchantOnboarding.step3.verifying': 'Vérification...',
    'merchantOnboarding.step3.verify': 'Vérifier',
    'merchantOnboarding.step3.whyRequired': 'Pourquoi est-ce requis ?',
    'merchantOnboarding.step3.whyRequiredDesc': 'Les réglementations bancaires exigent un traitement de paiement vérifié pour tous les marchands.',
    'merchantOnboarding.step3.noAccount': 'Vous n\'avez pas de compte ?',
    'merchantOnboarding.step3.createStripe': 'Créer un compte Stripe Connect',
    'merchantOnboarding.step3.quickActions': 'Actions rapides :',
    'merchantOnboarding.step3.createNewAccount': 'Créer un nouveau compte',
    'merchantOnboarding.step3.findMyId': 'Trouver mon ID de compte',
    'merchantOnboarding.step3.whereToFindId': 'Où trouver votre ID :',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Tableau de bord Stripe → Paramètres → Paramètres Connect → Votre ID de compte commence par "acct_"',
    'merchantOnboarding.step3.setupComplete': 'Votre traitement de paiement est configuré ! Vous pouvez maintenant recevoir des paiements des clients.',
    'merchantOnboarding.step3.paymentSettings': 'Paramètres de paiement',
    'merchantOnboarding.step3.acceptOnline': 'Accepter les paiements en ligne',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Permettre aux clients de payer en ligne',
    'merchantOnboarding.step3.acceptInStore': 'Accepter les paiements en magasin',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Accepter les paiements sur place',
    'merchantOnboarding.step4.title': 'Tout est prêt !',
    'merchantOnboarding.step4.subtitle': 'Votre compte marchand est prêt',
    'merchantOnboarding.step4.infoConfigured': 'Informations sur l\'entreprise configurées',
    'merchantOnboarding.step4.locationAdded': 'Localisation ajoutée',
    'merchantOnboarding.step4.paymentReady': 'Traitement des paiements prêt',
    'merchantOnboarding.step4.tourTitle': 'Souhaitez-vous une visite ?',
    'merchantOnboarding.step4.tourDesc': 'Familiarisez-vous avec vos outils et fonctionnalités de vendeur',
    'merchantOnboarding.step4.showTour': 'Montrez-moi les outils de vendeur',
    'merchantOnboarding.step4.tourDuration': 'Visite interactive de 5 minutes',
    'merchantOnboarding.step4.tourHint': 'Vous pouvez toujours accéder à la visite plus tard depuis votre tableau de bord marchand.',
    'merchantOnboarding.header': 'Configuration du marchand',
    'merchantOnboarding.step': 'Étape',
    'merchantOnboarding.back': 'Retour',
    'merchantOnboarding.next': 'Suivant',
    'merchantOnboarding.completingSetup': 'Finalisation de la configuration...',
    'merchantOnboarding.completeSetup': 'Terminer la configuration',
  },
  sq: {
    'merchantOnboarding.businessNameRequired': 'Emri i biznesit është i detyrueshëm',
    'merchantOnboarding.businessTypeRequired': 'Lloji i biznesit është i detyrueshëm',
    'merchantOnboarding.emailRequired': 'Email është i detyrueshëm',
    'merchantOnboarding.phoneRequired': 'Numri i telefonit është i detyrueshëm',
    'merchantOnboarding.streetRequired': 'Adresa e rrugës është e detyrueshme',
    'merchantOnboarding.cityRequired': 'Qyteti është i detyrueshëm',
    'merchantOnboarding.stateRequired': 'Shteti është i detyrueshëm',
    'merchantOnboarding.zipCodeRequired': 'Kodi postar është i detyrueshëm',
    'merchantOnboarding.stripeIdRequired': 'ID-ja e Stripe Connect është e detyrueshme',
    'merchantOnboarding.stripeIdFormat': 'ID-ja e Stripe Connect duhet të fillojë me "acct_"',
    'merchantOnboarding.stripeVerificationFailed': 'Verifikimi dështoi',
    'merchantOnboarding.accountLimited': 'Llogaria e Kufizuar',
    'merchantOnboarding.accountLimitedDesc': 'Llogaria juaj Stripe nuk mund të pranojë akoma tarifa. Ju lutemi plotësoni kërkesat e Stripe.',
    'merchantOnboarding.stripeConnectedLimited': 'Stripe i Lidhur (i Kufizuar)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Llogaria juaj mund të pranojë pagesa por nuk mund të marrë akoma pagesa. Kontrolloni Stripe për kërkesat.',
    'merchantOnboarding.stripeConnected': 'Stripe i Lidhur',
    'merchantOnboarding.stripeConnectedDesc': 'Llogaria e verifikuar! Ju mund të pranoni pagesa në {currency} në {country}.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'ID-ja e Stripe Connect nuk është e vlefshme ose nuk mund të verifikohej.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'Nuk mund të verifikohet ID-ja juaj e Stripe Connect. Ju lutemi kontrolloni dhe provoni përsëri.',
    'merchantOnboarding.setupComplete': 'Konfigurimi i Përfunduar!',
    'merchantOnboarding.setupCompleteDesc': 'Llogaria juaj e tregtarit është konfiguruar me sukses.',
    'merchantOnboarding.setupFailed': 'Konfigurimi Dështoi',
    'merchantOnboarding.setupFailedDesc': 'Nuk mund të përfundojë konfigurimi i tregtarit. Ju lutemi provoni përsëri.',
    'merchantOnboarding.step1.title': 'Informacioni i Biznesit',
    'merchantOnboarding.step1.subtitle': 'Na tregoni për biznesin tuaj',
    'merchantOnboarding.step1.businessName': 'Emri i Biznesit',
    'merchantOnboarding.step1.businessNamePlaceholder': 'Emri i Biznesit Tuaj',
    'merchantOnboarding.step1.businessType': 'Lloji i Biznesit',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Zgjidhni llojin e biznesit',
    'merchantOnboarding.step1.retail': 'Dyqan me Pakicë',
    'merchantOnboarding.step1.restaurant': 'Restorant',
    'merchantOnboarding.step1.service': 'Ofrues Shërbimi',
    'merchantOnboarding.step1.online': 'Biznes Online',
    'merchantOnboarding.step1.wholesale': 'Shitje me Shumicë',
    'merchantOnboarding.step1.other': 'Tjetër',
    'merchantOnboarding.step1.email': 'Email i Biznesit',
    'merchantOnboarding.step1.emailPlaceholder': 'biznes@shembull.com',
    'merchantOnboarding.step1.phone': 'Numri i Telefonit',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Faqe Web (Opsionale)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://biznesi-juaj.com',
    'merchantOnboarding.step1.logo': 'URL e Logos (Opsionale)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://biznesi-juaj.com/logo.png',
    'merchantOnboarding.step1.description': 'Përshkrimi i Biznesit',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Tregoni klientëve çfarë ofron biznesi juaj...',
    'merchantOnboarding.step2.title': 'Vendndodhja e Biznesit',
    'merchantOnboarding.step2.subtitle': 'Ku ndodhet biznesi juaj?',
    'merchantOnboarding.step2.street': 'Adresa e Rrugës',
    'merchantOnboarding.step2.streetPlaceholder': '123 Rruga Kryesore',
    'merchantOnboarding.step2.city': 'Qyteti',
    'merchantOnboarding.step2.cityPlaceholder': 'New York',
    'merchantOnboarding.step2.state': 'Shteti',
    'merchantOnboarding.step2.statePlaceholder': 'NY',
    'merchantOnboarding.step2.zip': 'Kodi Postar',
    'merchantOnboarding.step2.zipPlaceholder': '10001',
    'merchantOnboarding.step2.country': 'Shteti',
    'merchantOnboarding.step2.US': 'Shtetet e Bashkuara',
    'merchantOnboarding.step2.CA': 'Kanada',
    'merchantOnboarding.step2.MX': 'Meksika',
    'merchantOnboarding.step2.GB': 'Mbretëria e Bashkuar',
    'merchantOnboarding.step2.addressHint': 'Adresa juaj e biznesit do të jetë e dukshme për klientët dhe do të përdoret për rezultatet e kërkimit lokal.',
    'merchantOnboarding.step3.title': 'Konfigurimi i Pagesës',
    'merchantOnboarding.step3.subtitle': 'Lidhni llogarinë tuaj Stripe për të pranuar pagesa',
    'merchantOnboarding.step3.processingSetup': 'Konfigurimi i Përpunimit të Pagesës',
    'merchantOnboarding.step3.processingSetupDesc': 'Lidhni llogarinë tuaj Stripe për të marrë pagesa nga klientët (kërkohet nga rregullat bankare)',
    'merchantOnboarding.step3.stripeId': 'ID e Llogarisë së Përpunuesit të Pagesës (Stripe Connect)',
    'merchantOnboarding.step3.stripeIdHint': 'E kërkuar për të marrë fonde',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'E Verifikuar',
    'merchantOnboarding.step3.verifying': 'Duke verifikuar...',
    'merchantOnboarding.step3.verify': 'Verifiko',
    'merchantOnboarding.step3.whyRequired': 'Pse është kjo e detyrueshme?',
    'merchantOnboarding.step3.whyRequiredDesc': 'Rregullat bankare kërkojnë përpunim të verifikuar të pagesës për të gjithë tregtarët.',
    'merchantOnboarding.step3.noAccount': 'Nuk keni llogari?',
    'merchantOnboarding.step3.createStripe': 'Krijoni një llogari Stripe Connect',
    'merchantOnboarding.step3.quickActions': 'Veprime të Shpejta:',
    'merchantOnboarding.step3.createNewAccount': 'Krijoni Llogari të Re',
    'merchantOnboarding.step3.findMyId': 'Gjeni ID-në e Llogarisë sime',
    'merchantOnboarding.step3.whereToFindId': 'Ku të gjeni ID-në tuaj:',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Paneli Stripe → Cilësimet → Cilësimet e Connect → ID-ja juaj e llogarisë fillon me "acct_"',
    'merchantOnboarding.step3.setupComplete': 'Përpunimi juaj i pagesës është konfiguruar! Tani mund të merrni pagesa nga klientët.',
    'merchantOnboarding.step3.paymentSettings': 'Cilësimet e Pagesës',
    'merchantOnboarding.step3.acceptOnline': 'Prano Pagesa Online',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Lejoni klientët të paguajnë online',
    'merchantOnboarding.step3.acceptInStore': 'Prano Pagesa në Dyqan',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Prano pagesa në vendndodhje fizike',
    'merchantOnboarding.step4.title': 'Gjithçka është Gati!',
    'merchantOnboarding.step4.subtitle': 'Llogaria juaj e tregtarit është gati',
    'merchantOnboarding.step4.infoConfigured': 'Informacioni i biznesit i konfiguruar',
    'merchantOnboarding.step4.locationAdded': 'Vendndodhja e shtuar',
    'merchantOnboarding.step4.paymentReady': 'Përpunimi i pagesës gati',
    'merchantOnboarding.step4.tourTitle': 'Dëshironi një turne?',
    'merchantOnboarding.step4.tourDesc': 'Njihuni me mjetet dhe veçoritë tuaja të shitësit',
    'merchantOnboarding.step4.showTour': 'Më tregoni mjetet e shitësit',
    'merchantOnboarding.step4.tourDuration': 'Turne interaktiv 5-minutësh',
    'merchantOnboarding.step4.tourHint': 'Mund të aksesoni turneun më vonë nga pulti juaj i tregtarit.',
    'merchantOnboarding.header': 'Konfigurimi i Tregtarit',
    'merchantOnboarding.step': 'Hapi',
    'merchantOnboarding.back': 'Kthehu',
    'merchantOnboarding.next': 'Tjetra',
    'merchantOnboarding.completingSetup': 'Duke përfunduar konfigurimin...',
    'merchantOnboarding.completeSetup': 'Përfundo Konfigurimin',
  },
  ru: {
    'merchantOnboarding.businessNameRequired': 'Название бизнеса обязательно',
    'merchantOnboarding.businessTypeRequired': 'Тип бизнеса обязателен',
    'merchantOnboarding.emailRequired': 'Email обязателен',
    'merchantOnboarding.phoneRequired': 'Номер телефона обязателен',
    'merchantOnboarding.streetRequired': 'Адрес улицы обязателен',
    'merchantOnboarding.cityRequired': 'Город обязателен',
    'merchantOnboarding.stateRequired': 'Штат обязателен',
    'merchantOnboarding.zipCodeRequired': 'Почтовый индекс обязателен',
    'merchantOnboarding.stripeIdRequired': 'Stripe Connect ID обязателен',
    'merchantOnboarding.stripeIdFormat': 'Stripe Connect ID должен начинаться с "acct_"',
    'merchantOnboarding.stripeVerificationFailed': 'Верификация не удалась',
    'merchantOnboarding.accountLimited': 'Аккаунт ограничен',
    'merchantOnboarding.accountLimitedDesc': 'Ваш аккаунт Stripe еще не может принимать платежи. Пожалуйста, завершите требования Stripe.',
    'merchantOnboarding.stripeConnectedLimited': 'Stripe подключен (ограничен)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Ваш аккаунт может принимать платежи, но еще не может получать выплаты. Проверьте требования Stripe.',
    'merchantOnboarding.stripeConnected': 'Stripe подключен',
    'merchantOnboarding.stripeConnectedDesc': 'Аккаунт верифицирован! Вы можете принимать платежи в {currency} в {country}.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'Stripe Connect ID недействителен или не может быть верифицирован.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'Не удалось верифицировать ваш Stripe Connect ID. Пожалуйста, проверьте и попробуйте снова.',
    'merchantOnboarding.setupComplete': 'Настройка завершена!',
    'merchantOnboarding.setupCompleteDesc': 'Ваш аккаунт продавца успешно настроен.',
    'merchantOnboarding.setupFailed': 'Настройка не удалась',
    'merchantOnboarding.setupFailedDesc': 'Не удалось завершить настройку продавца. Пожалуйста, попробуйте снова.',
    'merchantOnboarding.step1.title': 'Информация о бизнесе',
    'merchantOnboarding.step1.subtitle': 'Расскажите нам о вашем бизнесе',
    'merchantOnboarding.step1.businessName': 'Название бизнеса',
    'merchantOnboarding.step1.businessNamePlaceholder': 'Название вашего бизнеса',
    'merchantOnboarding.step1.businessType': 'Тип бизнеса',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Выберите тип бизнеса',
    'merchantOnboarding.step1.retail': 'Розничный магазин',
    'merchantOnboarding.step1.restaurant': 'Ресторан',
    'merchantOnboarding.step1.service': 'Поставщик услуг',
    'merchantOnboarding.step1.online': 'Онлайн-бизнес',
    'merchantOnboarding.step1.wholesale': 'Оптовая торговля',
    'merchantOnboarding.step1.other': 'Другое',
    'merchantOnboarding.step1.email': 'Бизнес-email',
    'merchantOnboarding.step1.emailPlaceholder': 'business@example.com',
    'merchantOnboarding.step1.phone': 'Номер телефона',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Веб-сайт (необязательно)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://yourbusiness.com',
    'merchantOnboarding.step1.logo': 'URL логотипа (необязательно)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://yourbusiness.com/logo.png',
    'merchantOnboarding.step1.description': 'Описание бизнеса',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Расскажите клиентам, что предлагает ваш бизнес...',
    'merchantOnboarding.step2.title': 'Местоположение бизнеса',
    'merchantOnboarding.step2.subtitle': 'Где находится ваш бизнес?',
    'merchantOnboarding.step2.street': 'Адрес улицы',
    'merchantOnboarding.step2.streetPlaceholder': '123 Main Street',
    'merchantOnboarding.step2.city': 'Город',
    'merchantOnboarding.step2.cityPlaceholder': 'New York',
    'merchantOnboarding.step2.state': 'Штат',
    'merchantOnboarding.step2.statePlaceholder': 'NY',
    'merchantOnboarding.step2.zip': 'Почтовый индекс',
    'merchantOnboarding.step2.zipPlaceholder': '10001',
    'merchantOnboarding.step2.country': 'Страна',
    'merchantOnboarding.step2.US': 'Соединенные Штаты',
    'merchantOnboarding.step2.CA': 'Канада',
    'merchantOnboarding.step2.MX': 'Мексика',
    'merchantOnboarding.step2.GB': 'Соединенное Королевство',
    'merchantOnboarding.step2.addressHint': 'Адрес вашего бизнеса будет виден клиентам и использоваться для локальных результатов поиска.',
    'merchantOnboarding.step3.title': 'Настройка платежей',
    'merchantOnboarding.step3.subtitle': 'Подключите ваш аккаунт Stripe для приема платежей',
    'merchantOnboarding.step3.processingSetup': 'Настройка обработки платежей',
    'merchantOnboarding.step3.processingSetupDesc': 'Подключите ваш аккаунт Stripe для получения платежей от клиентов (требуется банковскими нормами)',
    'merchantOnboarding.step3.stripeId': 'ID аккаунта процессора платежей (Stripe Connect)',
    'merchantOnboarding.step3.stripeIdHint': 'Требуется для получения средств',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'Верифицировано',
    'merchantOnboarding.step3.verifying': 'Верификация...',
    'merchantOnboarding.step3.verify': 'Верифицировать',
    'merchantOnboarding.step3.whyRequired': 'Почему это требуется?',
    'merchantOnboarding.step3.whyRequiredDesc': 'Банковские нормативы требуют верифицированной обработки платежей для всех продавцов.',
    'merchantOnboarding.step3.noAccount': 'Нет аккаунта?',
    'merchantOnboarding.step3.createStripe': 'Создать аккаунт Stripe Connect',
    'merchantOnboarding.step3.quickActions': 'Быстрые действия:',
    'merchantOnboarding.step3.createNewAccount': 'Создать новый аккаунт',
    'merchantOnboarding.step3.findMyId': 'Найти мой ID аккаунта',
    'merchantOnboarding.step3.whereToFindId': 'Где найти ваш ID:',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Панель Stripe → Настройки → Настройки Connect → Ваш ID аккаунта начинается с "acct_"',
    'merchantOnboarding.step3.setupComplete': 'Ваша обработка платежей настроена! Теперь вы можете получать платежи от клиентов.',
    'merchantOnboarding.step3.paymentSettings': 'Настройки платежей',
    'merchantOnboarding.step3.acceptOnline': 'Принимать онлайн-платежи',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Разрешить клиентам платить онлайн',
    'merchantOnboarding.step3.acceptInStore': 'Принимать платежи в магазине',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Принимать платежи в физическом месте',
    'merchantOnboarding.step4.title': 'Все готово!',
    'merchantOnboarding.step4.subtitle': 'Ваш аккаунт продавца готов',
    'merchantOnboarding.step4.infoConfigured': 'Информация о бизнесе настроена',
    'merchantOnboarding.step4.locationAdded': 'Местоположение добавлено',
    'merchantOnboarding.step4.paymentReady': 'Обработка платежей готова',
    'merchantOnboarding.step4.tourTitle': 'Хотите тур?',
    'merchantOnboarding.step4.tourDesc': 'Ознакомьтесь с инструментами и функциями продавца',
    'merchantOnboarding.step4.showTour': 'Покажите мне инструменты продавца',
    'merchantOnboarding.step4.tourDuration': '5-минутный интерактивный тур',
    'merchantOnboarding.step4.tourHint': 'Вы всегда можете получить доступ к туру позже из панели продавца.',
    'merchantOnboarding.header': 'Настройка продавца',
    'merchantOnboarding.step': 'Шаг',
    'merchantOnboarding.back': 'Назад',
    'merchantOnboarding.next': 'Далее',
    'merchantOnboarding.completingSetup': 'Завершение настройки...',
    'merchantOnboarding.completeSetup': 'Завершить настройку',
  },
  pt: {
    'merchantOnboarding.businessNameRequired': 'Nome do negócio é obrigatório',
    'merchantOnboarding.businessTypeRequired': 'Tipo de negócio é obrigatório',
    'merchantOnboarding.emailRequired': 'Email é obrigatório',
    'merchantOnboarding.phoneRequired': 'Número de telefone é obrigatório',
    'merchantOnboarding.streetRequired': 'Endereço é obrigatório',
    'merchantOnboarding.cityRequired': 'Cidade é obrigatória',
    'merchantOnboarding.stateRequired': 'Estado é obrigatório',
    'merchantOnboarding.zipCodeRequired': 'CEP é obrigatório',
    'merchantOnboarding.stripeIdRequired': 'ID do Stripe Connect é obrigatório',
    'merchantOnboarding.stripeIdFormat': 'ID do Stripe Connect deve começar com "acct_"',
    'merchantOnboarding.stripeVerificationFailed': 'Verificação falhou',
    'merchantOnboarding.accountLimited': 'Conta Limitada',
    'merchantOnboarding.accountLimitedDesc': 'Sua conta Stripe ainda não pode aceitar cobranças. Por favor, complete os requisitos do Stripe.',
    'merchantOnboarding.stripeConnectedLimited': 'Stripe Conectado (Limitado)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Sua conta pode aceitar pagamentos, mas ainda não pode receber saques. Verifique o Stripe para requisitos.',
    'merchantOnboarding.stripeConnected': 'Stripe Conectado',
    'merchantOnboarding.stripeConnectedDesc': 'Conta verificada! Você pode aceitar pagamentos em {currency} em {country}.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'O ID do Stripe Connect não é válido ou não pôde ser verificado.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'Não foi possível verificar seu ID do Stripe Connect. Por favor, verifique e tente novamente.',
    'merchantOnboarding.setupComplete': 'Configuração Completa!',
    'merchantOnboarding.setupCompleteDesc': 'Sua conta de comerciante foi configurada com sucesso.',
    'merchantOnboarding.setupFailed': 'Configuração Falhou',
    'merchantOnboarding.setupFailedDesc': 'Não foi possível completar a configuração do comerciante. Por favor, tente novamente.',
    'merchantOnboarding.step1.title': 'Informações do Negócio',
    'merchantOnboarding.step1.subtitle': 'Conte-nos sobre seu negócio',
    'merchantOnboarding.step1.businessName': 'Nome do Negócio',
    'merchantOnboarding.step1.businessNamePlaceholder': 'Nome do Seu Negócio',
    'merchantOnboarding.step1.businessType': 'Tipo de Negócio',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Selecione o tipo de negócio',
    'merchantOnboarding.step1.retail': 'Loja de Varejo',
    'merchantOnboarding.step1.restaurant': 'Restaurante',
    'merchantOnboarding.step1.service': 'Prestador de Serviços',
    'merchantOnboarding.step1.online': 'Negócio Online',
    'merchantOnboarding.step1.wholesale': 'Atacado',
    'merchantOnboarding.step1.other': 'Outro',
    'merchantOnboarding.step1.email': 'Email do Negócio',
    'merchantOnboarding.step1.emailPlaceholder': 'negocio@exemplo.com',
    'merchantOnboarding.step1.phone': 'Número de Telefone',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Site (Opcional)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://seunegocio.com',
    'merchantOnboarding.step1.logo': 'URL do Logo (Opcional)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://seunegocio.com/logo.png',
    'merchantOnboarding.step1.description': 'Descrição do Negócio',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Conte aos clientes o que seu negócio oferece...',
    'merchantOnboarding.step2.title': 'Localização do Negócio',
    'merchantOnboarding.step2.subtitle': 'Onde está localizado seu negócio?',
    'merchantOnboarding.step2.street': 'Endereço',
    'merchantOnboarding.step2.streetPlaceholder': '123 Rua Principal',
    'merchantOnboarding.step2.city': 'Cidade',
    'merchantOnboarding.step2.cityPlaceholder': 'Nova York',
    'merchantOnboarding.step2.state': 'Estado',
    'merchantOnboarding.step2.statePlaceholder': 'NY',
    'merchantOnboarding.step2.zip': 'CEP',
    'merchantOnboarding.step2.zipPlaceholder': '10001',
    'merchantOnboarding.step2.country': 'País',
    'merchantOnboarding.step2.US': 'Estados Unidos',
    'merchantOnboarding.step2.CA': 'Canadá',
    'merchantOnboarding.step2.MX': 'México',
    'merchantOnboarding.step2.GB': 'Reino Unido',
    'merchantOnboarding.step2.addressHint': 'O endereço do seu negócio será visível para clientes e usado para resultados de busca local.',
    'merchantOnboarding.step3.title': 'Configuração de Pagamento',
    'merchantOnboarding.step3.subtitle': 'Conecte sua conta Stripe para aceitar pagamentos',
    'merchantOnboarding.step3.processingSetup': 'Configuração de Processamento de Pagamento',
    'merchantOnboarding.step3.processingSetupDesc': 'Conecte sua conta Stripe para receber pagamentos de clientes (exigido por regulamentações bancárias)',
    'merchantOnboarding.step3.stripeId': 'ID da Conta do Processador de Pagamento (Stripe Connect)',
    'merchantOnboarding.step3.stripeIdHint': 'Necessário para receber fundos',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'Verificado',
    'merchantOnboarding.step3.verifying': 'Verificando...',
    'merchantOnboarding.step3.verify': 'Verificar',
    'merchantOnboarding.step3.whyRequired': 'Por que isso é necessário?',
    'merchantOnboarding.step3.whyRequiredDesc': 'Regulamentações bancárias exigem processamento de pagamento verificado para todos os comerciantes.',
    'merchantOnboarding.step3.noAccount': 'Não tem uma conta?',
    'merchantOnboarding.step3.createStripe': 'Criar uma conta Stripe Connect',
    'merchantOnboarding.step3.quickActions': 'Ações Rápidas:',
    'merchantOnboarding.step3.createNewAccount': 'Criar Nova Conta',
    'merchantOnboarding.step3.findMyId': 'Encontrar Meu ID de Conta',
    'merchantOnboarding.step3.whereToFindId': 'Onde encontrar seu ID:',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Painel Stripe → Configurações → Configurações Connect → Seu ID de conta começa com "acct_"',
    'merchantOnboarding.step3.setupComplete': 'Seu processamento de pagamento está configurado! Agora você pode receber pagamentos de clientes.',
    'merchantOnboarding.step3.paymentSettings': 'Configurações de Pagamento',
    'merchantOnboarding.step3.acceptOnline': 'Aceitar Pagamentos Online',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Permitir que clientes paguem online',
    'merchantOnboarding.step3.acceptInStore': 'Aceitar Pagamentos na Loja',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Aceitar pagamentos em local físico',
    'merchantOnboarding.step4.title': 'Tudo Pronto!',
    'merchantOnboarding.step4.subtitle': 'Sua conta de comerciante está pronta',
    'merchantOnboarding.step4.infoConfigured': 'Informações do negócio configuradas',
    'merchantOnboarding.step4.locationAdded': 'Localização adicionada',
    'merchantOnboarding.step4.paymentReady': 'Processamento de pagamento pronto',
    'merchantOnboarding.step4.tourTitle': 'Gostaria de um tour?',
    'merchantOnboarding.step4.tourDesc': 'Familiarize-se com suas ferramentas e recursos de vendedor',
    'merchantOnboarding.step4.showTour': 'Mostre-me as ferramentas de vendedor',
    'merchantOnboarding.step4.tourDuration': 'Tour interativo de 5 minutos',
    'merchantOnboarding.step4.tourHint': 'Você sempre pode acessar o tour mais tarde do seu painel de comerciante.',
    'merchantOnboarding.header': 'Configuração do Comerciante',
    'merchantOnboarding.step': 'Passo',
    'merchantOnboarding.back': 'Voltar',
    'merchantOnboarding.next': 'Próximo',
    'merchantOnboarding.completingSetup': 'Completando Configuração...',
    'merchantOnboarding.completeSetup': 'Completar Configuração',
  },
  el: {
    'merchantOnboarding.businessNameRequired': 'Το όνομα της επιχείρησης είναι υποχρεωτικό',
    'merchantOnboarding.businessTypeRequired': 'Ο τύπος επιχείρησης είναι υποχρεωτικός',
    'merchantOnboarding.emailRequired': 'Το email είναι υποχρεωτικό',
    'merchantOnboarding.phoneRequired': 'Ο αριθμός τηλεφώνου είναι υποχρεωτικός',
    'merchantOnboarding.streetRequired': 'Η διεύθυνση οδού είναι υποχρεωτική',
    'merchantOnboarding.cityRequired': 'Η πόλη είναι υποχρεωτική',
    'merchantOnboarding.stateRequired': 'Η πολιτεία είναι υποχρεωτική',
    'merchantOnboarding.zipCodeRequired': 'Ο ταχυδρομικός κώδικας είναι υποχρεωτικός',
    'merchantOnboarding.stripeIdRequired': 'Το ID Stripe Connect είναι υποχρεωτικό',
    'merchantOnboarding.stripeIdFormat': 'Το ID Stripe Connect πρέπει να ξεκινά με "acct_"',
    'merchantOnboarding.stripeVerificationFailed': 'Η επαλήθευση απέτυχε',
    'merchantOnboarding.accountLimited': 'Περιορισμένος Λογαριασμός',
    'merchantOnboarding.accountLimitedDesc': 'Ο λογαριασμός σας Stripe δεν μπορεί ακόμα να δεχτεί χρεώσεις. Παρακαλώ ολοκληρώστε τις απαιτήσεις Stripe.',
    'merchantOnboarding.stripeConnectedLimited': 'Stripe Συνδεδεμένο (Περιορισμένο)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Ο λογαριασμός σας μπορεί να δεχτεί πληρωμές αλλά δεν μπορεί ακόμα να λάβει πληρωμές. Ελέγξτε το Stripe για απαιτήσεις.',
    'merchantOnboarding.stripeConnected': 'Stripe Συνδεδεμένο',
    'merchantOnboarding.stripeConnectedDesc': 'Ο λογαριασμός επαληθεύτηκε! Μπορείτε να δεχτείτε πληρωμές σε {currency} στην {country}.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'Το ID Stripe Connect δεν είναι έγκυρο ή δεν μπορούσε να επαληθευτεί.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'Δεν ήταν δυνατή η επαλήθευση του ID Stripe Connect σας. Παρακαλώ ελέγξτε και δοκιμάστε ξανά.',
    'merchantOnboarding.setupComplete': 'Η Ρύθμιση Ολοκληρώθηκε!',
    'merchantOnboarding.setupCompleteDesc': 'Ο λογαριασμός εμπόρου σας έχει ρυθμιστεί με επιτυχία.',
    'merchantOnboarding.setupFailed': 'Η Ρύθμιση Απέτυχε',
    'merchantOnboarding.setupFailedDesc': 'Δεν ήταν δυνατή η ολοκλήρωση της ρύθμισης εμπόρου. Παρακαλώ δοκιμάστε ξανά.',
    'merchantOnboarding.step1.title': 'Πληροφορίες Επιχείρησης',
    'merchantOnboarding.step1.subtitle': 'Πείτε μας για την επιχείρησή σας',
    'merchantOnboarding.step1.businessName': 'Όνομα Επιχείρησης',
    'merchantOnboarding.step1.businessNamePlaceholder': 'Το Όνομα της Επιχείρησής σας',
    'merchantOnboarding.step1.businessType': 'Τύπος Επιχείρησης',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Επιλέξτε τύπο επιχείρησης',
    'merchantOnboarding.step1.retail': 'Κατάστημα Λιανικής',
    'merchantOnboarding.step1.restaurant': 'Εστιατόριο',
    'merchantOnboarding.step1.service': 'Πάροχος Υπηρεσιών',
    'merchantOnboarding.step1.online': 'Διαδικτυακή Επιχείρηση',
    'merchantOnboarding.step1.wholesale': 'Χονδρική Πώληση',
    'merchantOnboarding.step1.other': 'Άλλο',
    'merchantOnboarding.step1.email': 'Email Επιχείρησης',
    'merchantOnboarding.step1.emailPlaceholder': 'epicheirisi@paradeigma.com',
    'merchantOnboarding.step1.phone': 'Αριθμός Τηλεφώνου',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Ιστοσελίδα (Προαιρετικό)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://epicheirisi-sas.com',
    'merchantOnboarding.step1.logo': 'URL Λογότυπου (Προαιρετικό)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://epicheirisi-sas.com/logo.png',
    'merchantOnboarding.step1.description': 'Περιγραφή Επιχείρησης',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Πείτε στους πελάτες τι προσφέρει η επιχείρησή σας...',
    'merchantOnboarding.step2.title': 'Τοποθεσία Επιχείρησης',
    'merchantOnboarding.step2.subtitle': 'Πού βρίσκεται η επιχείρησή σας;',
    'merchantOnboarding.step2.street': 'Διεύθυνση Οδού',
    'merchantOnboarding.step2.streetPlaceholder': '123 Κύρια Οδός',
    'merchantOnboarding.step2.city': 'Πόλη',
    'merchantOnboarding.step2.cityPlaceholder': 'Αθήνα',
    'merchantOnboarding.step2.state': 'Πολιτεία',
    'merchantOnboarding.step2.statePlaceholder': 'NY',
    'merchantOnboarding.step2.zip': 'Ταχυδρομικός Κώδικας',
    'merchantOnboarding.step2.zipPlaceholder': '10001',
    'merchantOnboarding.step2.country': 'Χώρα',
    'merchantOnboarding.step2.US': 'Ηνωμένες Πολιτείες',
    'merchantOnboarding.step2.CA': 'Καναδάς',
    'merchantOnboarding.step2.MX': 'Μεξικό',
    'merchantOnboarding.step2.GB': 'Ηνωμένο Βασίλειο',
    'merchantOnboarding.step2.addressHint': 'Η διεύθυνση της επιχείρησής σας θα είναι ορατή στους πελάτες και θα χρησιμοποιηθεί για αποτελέσματα τοπικής αναζήτησης.',
    'merchantOnboarding.step3.title': 'Ρύθμιση Πληρωμών',
    'merchantOnboarding.step3.subtitle': 'Συνδέστε τον λογαριασμό σας Stripe για να δεχτείτε πληρωμές',
    'merchantOnboarding.step3.processingSetup': 'Ρύθμιση Επεξεργασίας Πληρωμών',
    'merchantOnboarding.step3.processingSetupDesc': 'Συνδέστε τον λογαριασμό σας Stripe για να λάβετε πληρωμές από πελάτες (απαιτείται από τραπεζικούς κανονισμούς)',
    'merchantOnboarding.step3.stripeId': 'ID Λογαριασμού Επεξεργαστή Πληρωμών (Stripe Connect)',
    'merchantOnboarding.step3.stripeIdHint': 'Απαιτείται για λήψη κεφαλαίων',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'Επαληθευμένο',
    'merchantOnboarding.step3.verifying': 'Επαλήθευση...',
    'merchantOnboarding.step3.verify': 'Επαλήθευση',
    'merchantOnboarding.step3.whyRequired': 'Γιατί είναι αυτό απαραίτητο;',
    'merchantOnboarding.step3.whyRequiredDesc': 'Οι τραπεζικοί κανονισμοί απαιτούν επαληθευμένη επεξεργασία πληρωμών για όλους τους εμπόρους.',
    'merchantOnboarding.step3.noAccount': 'Δεν έχετε λογαριασμό;',
    'merchantOnboarding.step3.createStripe': 'Δημιουργήστε λογαριασμό Stripe Connect',
    'merchantOnboarding.step3.quickActions': 'Γρήγορες Ενέργειες:',
    'merchantOnboarding.step3.createNewAccount': 'Δημιουργία Νέου Λογαριασμού',
    'merchantOnboarding.step3.findMyId': 'Βρείτε το ID Λογαριασμού μου',
    'merchantOnboarding.step3.whereToFindId': 'Πού να βρείτε το ID σας:',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Πίνακας Ελέγχου Stripe → Ρυθμίσεις → Ρυθμίσεις Connect → Το ID λογαριασμού σας ξεκινά με "acct_"',
    'merchantOnboarding.step3.setupComplete': 'Η επεξεργασία πληρωμών σας έχει ρυθμιστεί! Μπορείτε τώρα να λάβετε πληρωμές από πελάτες.',
    'merchantOnboarding.step3.paymentSettings': 'Ρυθμίσεις Πληρωμών',
    'merchantOnboarding.step3.acceptOnline': 'Αποδοχή Διαδικτυακών Πληρωμών',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Επιτρέψτε στους πελάτες να πληρώσουν online',
    'merchantOnboarding.step3.acceptInStore': 'Αποδοχή Πληρωμών στο Κατάστημα',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Αποδοχή πληρωμών σε φυσική τοποθεσία',
    'merchantOnboarding.step4.title': 'Όλα Έτοιμα!',
    'merchantOnboarding.step4.subtitle': 'Ο λογαριασμός εμπόρου σας είναι έτοιμος',
    'merchantOnboarding.step4.infoConfigured': 'Πληροφορίες επιχείρησης ρυθμισμένες',
    'merchantOnboarding.step4.locationAdded': 'Τοποθεσία προστέθηκε',
    'merchantOnboarding.step4.paymentReady': 'Επεξεργασία πληρωμών έτοιμη',
    'merchantOnboarding.step4.tourTitle': 'Θα θέλατε μια ξενάγηση;',
    'merchantOnboarding.step4.tourDesc': 'Εξοικειωθείτε με τα εργαλεία και τις λειτουργίες πωλητή σας',
    'merchantOnboarding.step4.showTour': 'Δείξτε μου τα εργαλεία πωλητή',
    'merchantOnboarding.step4.tourDuration': 'Διαδραστική ξενάγηση 5 λεπτών',
    'merchantOnboarding.step4.tourHint': 'Μπορείτε πάντα να αποκτήσετε πρόσβαση στην ξενάγηση αργότερα από τον πίνακα ελέγχου εμπόρου σας.',
    'merchantOnboarding.header': 'Ρύθμιση Εμπόρου',
    'merchantOnboarding.step': 'Βήμα',
    'merchantOnboarding.back': 'Πίσω',
    'merchantOnboarding.next': 'Επόμενο',
    'merchantOnboarding.completingSetup': 'Ολοκλήρωση ρύθμισης...',
    'merchantOnboarding.completeSetup': 'Ολοκλήρωση Ρύθμισης',
  },
  de: {
    'merchantOnboarding.businessNameRequired': 'Geschäftsname ist erforderlich',
    'merchantOnboarding.businessTypeRequired': 'Geschäftstyp ist erforderlich',
    'merchantOnboarding.emailRequired': 'E-Mail ist erforderlich',
    'merchantOnboarding.phoneRequired': 'Telefonnummer ist erforderlich',
    'merchantOnboarding.streetRequired': 'Straßenadresse ist erforderlich',
    'merchantOnboarding.cityRequired': 'Stadt ist erforderlich',
    'merchantOnboarding.stateRequired': 'Bundesstaat ist erforderlich',
    'merchantOnboarding.zipCodeRequired': 'Postleitzahl ist erforderlich',
    'merchantOnboarding.stripeIdRequired': 'Stripe Connect ID ist erforderlich',
    'merchantOnboarding.stripeIdFormat': 'Stripe Connect ID muss mit "acct_" beginnen',
    'merchantOnboarding.stripeVerificationFailed': 'Verifizierung fehlgeschlagen',
    'merchantOnboarding.accountLimited': 'Konto eingeschränkt',
    'merchantOnboarding.accountLimitedDesc': 'Ihr Stripe-Konto kann noch keine Gebühren akzeptieren. Bitte vervollständigen Sie die Stripe-Anforderungen.',
    'merchantOnboarding.stripeConnectedLimited': 'Stripe verbunden (eingeschränkt)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Ihr Konto kann Zahlungen akzeptieren, kann aber noch keine Auszahlungen erhalten. Überprüfen Sie Stripe auf Anforderungen.',
    'merchantOnboarding.stripeConnected': 'Stripe verbunden',
    'merchantOnboarding.stripeConnectedDesc': 'Konto verifiziert! Sie können {currency}-Zahlungen in {country} akzeptieren.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'Die Stripe Connect ID ist nicht gültig oder konnte nicht verifiziert werden.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'Ihre Stripe Connect ID konnte nicht verifiziert werden. Bitte überprüfen Sie sie und versuchen Sie es erneut.',
    'merchantOnboarding.setupComplete': 'Einrichtung abgeschlossen!',
    'merchantOnboarding.setupCompleteDesc': 'Ihr Händlerkonto wurde erfolgreich eingerichtet.',
    'merchantOnboarding.setupFailed': 'Einrichtung fehlgeschlagen',
    'merchantOnboarding.setupFailedDesc': 'Händler-Einrichtung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
    'merchantOnboarding.step1.title': 'Geschäftsinformationen',
    'merchantOnboarding.step1.subtitle': 'Erzählen Sie uns von Ihrem Geschäft',
    'merchantOnboarding.step1.businessName': 'Geschäftsname',
    'merchantOnboarding.step1.businessNamePlaceholder': 'Ihr Geschäftsname',
    'merchantOnboarding.step1.businessType': 'Geschäftstyp',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Geschäftstyp auswählen',
    'merchantOnboarding.step1.retail': 'Einzelhandelsgeschäft',
    'merchantOnboarding.step1.restaurant': 'Restaurant',
    'merchantOnboarding.step1.service': 'Dienstleister',
    'merchantOnboarding.step1.online': 'Online-Geschäft',
    'merchantOnboarding.step1.wholesale': 'Großhandel',
    'merchantOnboarding.step1.other': 'Sonstiges',
    'merchantOnboarding.step1.email': 'Geschäfts-E-Mail',
    'merchantOnboarding.step1.emailPlaceholder': 'geschaeft@beispiel.com',
    'merchantOnboarding.step1.phone': 'Telefonnummer',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Website (Optional)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://ihrgeschaeft.com',
    'merchantOnboarding.step1.logo': 'Logo-URL (Optional)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://ihrgeschaeft.com/logo.png',
    'merchantOnboarding.step1.description': 'Geschäftsbeschreibung',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Erzählen Sie Kunden, was Ihr Geschäft bietet...',
    'merchantOnboarding.step2.title': 'Geschäftsstandort',
    'merchantOnboarding.step2.subtitle': 'Wo befindet sich Ihr Geschäft?',
    'merchantOnboarding.step2.street': 'Straßenadresse',
    'merchantOnboarding.step2.streetPlaceholder': '123 Hauptstraße',
    'merchantOnboarding.step2.city': 'Stadt',
    'merchantOnboarding.step2.cityPlaceholder': 'New York',
    'merchantOnboarding.step2.state': 'Bundesstaat',
    'merchantOnboarding.step2.statePlaceholder': 'NY',
    'merchantOnboarding.step2.zip': 'Postleitzahl',
    'merchantOnboarding.step2.zipPlaceholder': '10001',
    'merchantOnboarding.step2.country': 'Land',
    'merchantOnboarding.step2.US': 'Vereinigte Staaten',
    'merchantOnboarding.step2.CA': 'Kanada',
    'merchantOnboarding.step2.MX': 'Mexiko',
    'merchantOnboarding.step2.GB': 'Vereinigtes Königreich',
    'merchantOnboarding.step2.addressHint': 'Ihre Geschäftsadresse wird für Kunden sichtbar sein und für lokale Suchergebnisse verwendet.',
    'merchantOnboarding.step3.title': 'Zahlungseinrichtung',
    'merchantOnboarding.step3.subtitle': 'Verbinden Sie Ihr Stripe-Konto, um Zahlungen zu akzeptieren',
    'merchantOnboarding.step3.processingSetup': 'Zahlungsverarbeitungs-Einrichtung',
    'merchantOnboarding.step3.processingSetupDesc': 'Verbinden Sie Ihr Stripe-Konto, um Zahlungen von Kunden zu erhalten (von Bankvorschriften erforderlich)',
    'merchantOnboarding.step3.stripeId': 'Zahlungsprozessor-Konto-ID (Stripe Connect)',
    'merchantOnboarding.step3.stripeIdHint': 'Erforderlich zum Empfangen von Geldern',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'Verifiziert',
    'merchantOnboarding.step3.verifying': 'Wird verifiziert...',
    'merchantOnboarding.step3.verify': 'Verifizieren',
    'merchantOnboarding.step3.whyRequired': 'Warum ist dies erforderlich?',
    'merchantOnboarding.step3.whyRequiredDesc': 'Bankvorschriften erfordern eine verifizierte Zahlungsverarbeitung für alle Händler.',
    'merchantOnboarding.step3.noAccount': 'Haben Sie kein Konto?',
    'merchantOnboarding.step3.createStripe': 'Ein Stripe Connect-Konto erstellen',
    'merchantOnboarding.step3.quickActions': 'Schnellaktionen:',
    'merchantOnboarding.step3.createNewAccount': 'Neues Konto erstellen',
    'merchantOnboarding.step3.findMyId': 'Meine Konto-ID finden',
    'merchantOnboarding.step3.whereToFindId': 'Wo Sie Ihre ID finden:',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Stripe-Dashboard → Einstellungen → Connect-Einstellungen → Ihre Konto-ID beginnt mit "acct_"',
    'merchantOnboarding.step3.setupComplete': 'Ihre Zahlungsverarbeitung ist eingerichtet! Sie können jetzt Zahlungen von Kunden erhalten.',
    'merchantOnboarding.step3.paymentSettings': 'Zahlungseinstellungen',
    'merchantOnboarding.step3.acceptOnline': 'Online-Zahlungen akzeptieren',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Kunden ermöglichen, online zu zahlen',
    'merchantOnboarding.step3.acceptInStore': 'Laden-Zahlungen akzeptieren',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Zahlungen an physischem Standort akzeptieren',
    'merchantOnboarding.step4.title': 'Alles fertig!',
    'merchantOnboarding.step4.subtitle': 'Ihr Händlerkonto ist bereit',
    'merchantOnboarding.step4.infoConfigured': 'Geschäftsinformationen konfiguriert',
    'merchantOnboarding.step4.locationAdded': 'Standort hinzugefügt',
    'merchantOnboarding.step4.paymentReady': 'Zahlungsverarbeitung bereit',
    'merchantOnboarding.step4.tourTitle': 'Möchten Sie eine Tour?',
    'merchantOnboarding.step4.tourDesc': 'Machen Sie sich mit Ihren Verkaufstools und Funktionen vertraut',
    'merchantOnboarding.step4.showTour': 'Zeigen Sie mir die Verkaufstools',
    'merchantOnboarding.step4.tourDuration': '5-minütige interaktive Tour',
    'merchantOnboarding.step4.tourHint': 'Sie können die Tour später jederzeit über Ihr Händler-Dashboard aufrufen.',
    'merchantOnboarding.header': 'Händler-Einrichtung',
    'merchantOnboarding.step': 'Schritt',
    'merchantOnboarding.back': 'Zurück',
    'merchantOnboarding.next': 'Weiter',
    'merchantOnboarding.completingSetup': 'Einrichtung wird abgeschlossen...',
    'merchantOnboarding.completeSetup': 'Einrichtung abschließen',
  },
  ro: {
    'merchantOnboarding.businessNameRequired': 'Numele afacerii este obligatoriu',
    'merchantOnboarding.businessTypeRequired': 'Tipul afacerii este obligatoriu',
    'merchantOnboarding.emailRequired': 'Emailul este obligatoriu',
    'merchantOnboarding.phoneRequired': 'Numărul de telefon este obligatoriu',
    'merchantOnboarding.streetRequired': 'Adresa străzii este obligatorie',
    'merchantOnboarding.cityRequired': 'Orașul este obligatoriu',
    'merchantOnboarding.stateRequired': 'Județul este obligatoriu',
    'merchantOnboarding.zipCodeRequired': 'Codul poștal este obligatoriu',
    'merchantOnboarding.stripeIdRequired': 'ID-ul Stripe Connect este obligatoriu',
    'merchantOnboarding.stripeIdFormat': 'ID-ul Stripe Connect trebuie să înceapă cu "acct_"',
    'merchantOnboarding.stripeVerificationFailed': 'Verificarea a eșuat',
    'merchantOnboarding.accountLimited': 'Cont Limitât',
    'merchantOnboarding.accountLimitedDesc': 'Contul dvs. Stripe nu poate accepta încă plăți. Vă rugăm să completați cerințele Stripe.',
    'merchantOnboarding.stripeConnectedLimited': 'Stripe Conectat (Limitât)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Contul dvs. poate accepta plăți dar nu poate primi încă transferuri. Verificați Stripe pentru cerințe.',
    'merchantOnboarding.stripeConnected': 'Stripe Conectat',
    'merchantOnboarding.stripeConnectedDesc': 'Cont verificat! Puteți accepta plăți în {currency} în {country}.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'ID-ul Stripe Connect nu este valid sau nu a putut fi verificat.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'Nu s-a putut verifica ID-ul dvs. Stripe Connect. Vă rugăm să verificați și să încercați din nou.',
    'merchantOnboarding.setupComplete': 'Configurare Completă!',
    'merchantOnboarding.setupCompleteDesc': 'Contul dvs. de comerciant a fost configurat cu succes.',
    'merchantOnboarding.setupFailed': 'Configurare Eșuată',
    'merchantOnboarding.setupFailedDesc': 'Nu s-a putut completa configurarea comerciantului. Vă rugăm să încercați din nou.',
    'merchantOnboarding.step1.title': 'Informații Afacere',
    'merchantOnboarding.step1.subtitle': 'Spuneți-ne despre afacerea dvs.',
    'merchantOnboarding.step1.businessName': 'Nume Afacere',
    'merchantOnboarding.step1.businessNamePlaceholder': 'Numele Afacerii Dvs.',
    'merchantOnboarding.step1.businessType': 'Tip Afacere',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Selectați tipul de afacere',
    'merchantOnboarding.step1.retail': 'Magazin de Vânzare cu Amănuntul',
    'merchantOnboarding.step1.restaurant': 'Restaurant',
    'merchantOnboarding.step1.service': 'Furnizor de Servicii',
    'merchantOnboarding.step1.online': 'Afacere Online',
    'merchantOnboarding.step1.wholesale': 'En Gros',
    'merchantOnboarding.step1.other': 'Altul',
    'merchantOnboarding.step1.email': 'Email Afacere',
    'merchantOnboarding.step1.emailPlaceholder': 'afacere@exemplu.com',
    'merchantOnboarding.step1.phone': 'Număr de Telefon',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Site Web (Opțional)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://afacereadvs.com',
    'merchantOnboarding.step1.logo': 'URL Logo (Opțional)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://afacereadvs.com/logo.png',
    'merchantOnboarding.step1.description': 'Descriere Afacere',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Spuneți clienților ce oferă afacerea dvs...',
    'merchantOnboarding.step2.title': 'Locația Afacerii',
    'merchantOnboarding.step2.subtitle': 'Unde este situată afacerea dvs.?',
    'merchantOnboarding.step2.street': 'Adresă Stradă',
    'merchantOnboarding.step2.streetPlaceholder': '123 Strada Principală',
    'merchantOnboarding.step2.city': 'Oraș',
    'merchantOnboarding.step2.cityPlaceholder': 'București',
    'merchantOnboarding.step2.state': 'Județ',
    'merchantOnboarding.step2.statePlaceholder': 'B',
    'merchantOnboarding.step2.zip': 'Cod Poștal',
    'merchantOnboarding.step2.zipPlaceholder': '10001',
    'merchantOnboarding.step2.country': 'Țară',
    'merchantOnboarding.step2.US': 'Statele Unite',
    'merchantOnboarding.step2.CA': 'Canada',
    'merchantOnboarding.step2.MX': 'Mexic',
    'merchantOnboarding.step2.GB': 'Regatul Unit',
    'merchantOnboarding.step2.addressHint': 'Adresa afacerii dvs. va fi vizibilă clienților și va fi folosită pentru rezultatele de căutare locală.',
    'merchantOnboarding.step3.title': 'Configurare Plăți',
    'merchantOnboarding.step3.subtitle': 'Conectați-vă contul Stripe pentru a accepta plăți',
    'merchantOnboarding.step3.processingSetup': 'Configurare Procesare Plăți',
    'merchantOnboarding.step3.processingSetupDesc': 'Conectați-vă contul Stripe pentru a primi plăți de la clienți (necesar de reglementările bancare)',
    'merchantOnboarding.step3.stripeId': 'ID Cont Procesator Plăți (Stripe Connect)',
    'merchantOnboarding.step3.stripeIdHint': 'Necesar pentru a primi fonduri',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'Verificat',
    'merchantOnboarding.step3.verifying': 'Se verifică...',
    'merchantOnboarding.step3.verify': 'Verifică',
    'merchantOnboarding.step3.whyRequired': 'De ce este necesar?',
    'merchantOnboarding.step3.whyRequiredDesc': 'Reglementările bancare cer procesare de plăți verificată pentru toți comercianții.',
    'merchantOnboarding.step3.noAccount': 'Nu aveți un cont?',
    'merchantOnboarding.step3.createStripe': 'Creați un cont Stripe Connect',
    'merchantOnboarding.step3.quickActions': 'Acțiuni Rapide:',
    'merchantOnboarding.step3.createNewAccount': 'Creați Cont Nou',
    'merchantOnboarding.step3.findMyId': 'Găsiți ID-ul Contului Meu',
    'merchantOnboarding.step3.whereToFindId': 'Unde să găsiți ID-ul dvs.:',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Panou Stripe → Setări → Setări Connect → ID-ul contului dvs. începe cu "acct_"',
    'merchantOnboarding.step3.setupComplete': 'Procesarea plăților dvs. este configurată! Acum puteți primi plăți de la clienți.',
    'merchantOnboarding.step3.paymentSettings': 'Setări Plăți',
    'merchantOnboarding.step3.acceptOnline': 'Acceptă Plăți Online',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Permiteți clienților să plătească online',
    'merchantOnboarding.step3.acceptInStore': 'Acceptă Plăți în Magazin',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Acceptați plăți la locație fizică',
    'merchantOnboarding.step4.title': 'Totul Este Gata!',
    'merchantOnboarding.step4.subtitle': 'Contul dvs. de comerciant este gata',
    'merchantOnboarding.step4.infoConfigured': 'Informații afacere configurate',
    'merchantOnboarding.step4.locationAdded': 'Locație adăugată',
    'merchantOnboarding.step4.paymentReady': 'Procesare plăți gata',
    'merchantOnboarding.step4.tourTitle': 'Ați dori un tur?',
    'merchantOnboarding.step4.tourDesc': 'Familiarizați-vă cu instrumentele și funcțiile dvs. de vânzător',
    'merchantOnboarding.step4.showTour': 'Arătați-mi instrumentele de vânzător',
    'merchantOnboarding.step4.tourDuration': 'Tur interactiv de 5 minute',
    'merchantOnboarding.step4.tourHint': 'Puteți accesa turul mai târziu din panoul dvs. de comerciant.',
    'merchantOnboarding.header': 'Configurare Comerciant',
    'merchantOnboarding.step': 'Pas',
    'merchantOnboarding.back': 'Înapoi',
    'merchantOnboarding.next': 'Următorul',
    'merchantOnboarding.completingSetup': 'Se finalizează Configurarea...',
    'merchantOnboarding.completeSetup': 'Finalizează Configurarea',
  },
  sr: {
    'merchantOnboarding.businessNameRequired': 'Назив предузећа је обавезан',
    'merchantOnboarding.businessTypeRequired': 'Тип предузећа је обавезан',
    'merchantOnboarding.emailRequired': 'Имејл је обавезан',
    'merchantOnboarding.phoneRequired': 'Број телефона је обавезан',
    'merchantOnboarding.streetRequired': 'Адреса је обавезна',
    'merchantOnboarding.cityRequired': 'Град је обавезан',
    'merchantOnboarding.stateRequired': 'Држава је обавезна',
    'merchantOnboarding.zipCodeRequired': 'Поштански број је обавезан',
    'merchantOnboarding.stripeIdRequired': 'Стрипе Цоннецт ИД је обавезан',
    'merchantOnboarding.stripeIdFormat': 'Стрипе Цоннецт ИД мора почети са "acct_"',
    'merchantOnboarding.stripeVerificationFailed': 'Верификација неуспешна',
    'merchantOnboarding.accountLimited': 'Налог ограничен',
    'merchantOnboarding.accountLimitedDesc': 'Ваш Стрипе налог још увек не може да прихвата наплате. Молимо вас да испуните Стрипе захтеве.',
    'merchantOnboarding.stripeConnectedLimited': 'Стрипе повезан (ограничено)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Ваш налог може да прихвата уплате, али још увек не може да прима исплате. Проверите Стрипе за захтеве.',
    'merchantOnboarding.stripeConnected': 'Стрипе повезан',
    'merchantOnboarding.stripeConnectedDesc': 'Налог верификован! Можете прихватити {currency} уплате у {country}.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'Стрипе Цоннецт ИД није важећи или није могао бити верификован.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'Није могуће верификовати ваш Стрипе Цоннецт ИД. Проверите и покушајте поново.',
    'merchantOnboarding.setupComplete': 'Подешавање завршено!',
    'merchantOnboarding.setupCompleteDesc': 'Ваш трговачки налог је успешно подешен.',
    'merchantOnboarding.setupFailed': 'Подешавање неуспешно',
    'merchantOnboarding.setupFailedDesc': 'Није могуће завршити подешавање трговца. Покушајте поново.',
    'merchantOnboarding.step1.title': 'Информације о предузећу',
    'merchantOnboarding.step1.subtitle': 'Реците нам нешто о вашем предузећу',
    'merchantOnboarding.step1.businessName': 'Назив предузећа',
    'merchantOnboarding.step1.businessNamePlaceholder': 'Назив вашег предузећа',
    'merchantOnboarding.step1.businessType': 'Тип предузећа',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Изаберите тип предузећа',
    'merchantOnboarding.step1.retail': 'Малопродаја',
    'merchantOnboarding.step1.restaurant': 'Ресторан',
    'merchantOnboarding.step1.service': 'Пружалац услуга',
    'merchantOnboarding.step1.online': 'Онлине предузеће',
    'merchantOnboarding.step1.wholesale': 'Велепродаја',
    'merchantOnboarding.step1.other': 'Остало',
    'merchantOnboarding.step1.email': 'Пословни имејл',
    'merchantOnboarding.step1.emailPlaceholder': 'posao@primer.com',
    'merchantOnboarding.step1.phone': 'Број телефона',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Веб сајт (опционо)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://vasbiznis.com',
    'merchantOnboarding.step1.logo': 'УРЛ логотипа (опционо)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://vasbiznis.com/logo.png',
    'merchantOnboarding.step1.description': 'Опис предузећа',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Реците купцима шта ваше предузеће нуди...',
    'merchantOnboarding.step2.title': 'Локација предузећа',
    'merchantOnboarding.step2.subtitle': 'Где се налази ваше предузеће?',
    'merchantOnboarding.step2.street': 'Адреса',
    'merchantOnboarding.step2.streetPlaceholder': '123 Главна улица',
    'merchantOnboarding.step2.city': 'Град',
    'merchantOnboarding.step2.cityPlaceholder': 'Њујорк',
    'merchantOnboarding.step2.state': 'Држава',
    'merchantOnboarding.step2.statePlaceholder': 'НY',
    'merchantOnboarding.step2.zip': 'Поштански број',
    'merchantOnboarding.step2.zipPlaceholder': '10001',
    'merchantOnboarding.step2.country': 'Држава',
    'merchantOnboarding.step2.US': 'Сједињене Државе',
    'merchantOnboarding.step2.CA': 'Канада',
    'merchantOnboarding.step2.MX': 'Мексико',
    'merchantOnboarding.step2.GB': 'Уједињено Краљевство',
    'merchantOnboarding.step2.addressHint': 'Адреса вашег предузећа биће видљива купцима и користиће се за резултате локалне претраге.',
    'merchantOnboarding.step3.title': 'Подешавање плаћања',
    'merchantOnboarding.step3.subtitle': 'Повежите свој Стрипе налог да бисте прихватили уплате',
    'merchantOnboarding.step3.processingSetup': 'Подешавање обраде плаћања',
    'merchantOnboarding.step3.processingSetupDesc': 'Повежите свој Стрипе налог да бисте примали уплате од купаца (захтевано од стране банкарских прописа)',
    'merchantOnboarding.step3.stripeId': 'ИД налога процесора плаћања (Стрипе Цоннецт)',
    'merchantOnboarding.step3.stripeIdHint': 'Обавезно за примање средстава',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'Верификовано',
    'merchantOnboarding.step3.verifying': 'Верификација...',
    'merchantOnboarding.step3.verify': 'Верификуј',
    'merchantOnboarding.step3.whyRequired': 'Зашто је ово обавезно?',
    'merchantOnboarding.step3.whyRequiredDesc': 'Банкарски прописи захтевају верификовану обраду плаћања за све трговце.',
    'merchantOnboarding.step3.noAccount': 'Немате налог?',
    'merchantOnboarding.step3.createStripe': 'Креирајте Стрипе Цоннецт налог',
    'merchantOnboarding.step3.quickActions': 'Брзе акције:',
    'merchantOnboarding.step3.createNewAccount': 'Креирај нови налог',
    'merchantOnboarding.step3.findMyId': 'Пронађи мој ИД налога',
    'merchantOnboarding.step3.whereToFindId': 'Где пронаћи свој ИД:',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Стрипе контролна табла → Подешавања → Цоннецт подешавања → Ваш ИД налога почиње са "acct_"',
    'merchantOnboarding.step3.setupComplete': 'Ваша обрада плаћања је подешена! Сада можете примати уплате од купаца.',
    'merchantOnboarding.step3.paymentSettings': 'Подешавања плаћања',
    'merchantOnboarding.step3.acceptOnline': 'Прихвати онлине уплате',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Дозволите купцима да плаћају онлине',
    'merchantOnboarding.step3.acceptInStore': 'Прихвати уплате у продавници',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Прихватите уплате на физичкој локацији',
    'merchantOnboarding.step4.title': 'Све је спремно!',
    'merchantOnboarding.step4.subtitle': 'Ваш трговачки налог је спреман',
    'merchantOnboarding.step4.infoConfigured': 'Информације о предузећу конфигурисане',
    'merchantOnboarding.step4.locationAdded': 'Локација додата',
    'merchantOnboarding.step4.paymentReady': 'Обрада плаћања спремна',
    'merchantOnboarding.step4.tourTitle': 'Желите ли обилазак?',
    'merchantOnboarding.step4.tourDesc': 'Упознајте се са алатима и функцијама за продавце',
    'merchantOnboarding.step4.showTour': 'Покажи ми алате за продавце',
    'merchantOnboarding.step4.tourDuration': 'Интерактивни обилазак од 5 минута',
    'merchantOnboarding.step4.tourHint': 'Увек можете касније приступити обиласку са ваше контролне табле трговца.',
    'merchantOnboarding.header': 'Подешавање трговца',
    'merchantOnboarding.step': 'Корак',
    'merchantOnboarding.back': 'Назад',
    'merchantOnboarding.next': 'Следећи',
    'merchantOnboarding.completingSetup': 'Завршавање подешавања...',
    'merchantOnboarding.completeSetup': 'Заврши подешавање',
  },
  pl: {
    'merchantOnboarding.businessNameRequired': 'Nazwa firmy jest wymagana',
    'merchantOnboarding.businessTypeRequired': 'Typ firmy jest wymagany',
    'merchantOnboarding.emailRequired': 'Email jest wymagany',
    'merchantOnboarding.phoneRequired': 'Numer telefonu jest wymagany',
    'merchantOnboarding.streetRequired': 'Adres ulicy jest wymagany',
    'merchantOnboarding.cityRequired': 'Miasto jest wymagane',
    'merchantOnboarding.stateRequired': 'Województwo jest wymagane',
    'merchantOnboarding.zipCodeRequired': 'Kod pocztowy jest wymagany',
    'merchantOnboarding.stripeIdRequired': 'ID Stripe Connect jest wymagane',
    'merchantOnboarding.stripeIdFormat': 'ID Stripe Connect musi zaczynać się od "acct_"',
    'merchantOnboarding.stripeVerificationFailed': 'Weryfikacja nie powiodła się',
    'merchantOnboarding.accountLimited': 'Konto Ograniczone',
    'merchantOnboarding.accountLimitedDesc': 'Twoje konto Stripe nie może jeszcze akceptować opłat. Proszę uzupełnić wymagania Stripe.',
    'merchantOnboarding.stripeConnectedLimited': 'Stripe Połączone (Ograniczone)',
    'merchantOnboarding.stripeConnectedLimitedDesc': 'Twoje konto może akceptować płatności, ale nie może jeszcze otrzymywać wypłat. Sprawdź Stripe pod kątem wymagań.',
    'merchantOnboarding.stripeConnected': 'Stripe Połączone',
    'merchantOnboarding.stripeConnectedDesc': 'Konto zweryfikowane! Możesz akceptować płatności w {currency} w {country}.',
    'merchantOnboarding.stripeVerificationFailedDesc': 'ID Stripe Connect jest nieprawidłowe lub nie mogło zostać zweryfikowane.',
    'merchantOnboarding.stripeVerificationFailedGeneric': 'Nie można zweryfikować Twojego ID Stripe Connect. Proszę sprawdzić i spróbować ponownie.',
    'merchantOnboarding.setupComplete': 'Konfiguracja Zakończona!',
    'merchantOnboarding.setupCompleteDesc': 'Twoje konto sprzedawcy zostało pomyślnie skonfigurowane.',
    'merchantOnboarding.setupFailed': 'Konfiguracja Nie Powiodła Się',
    'merchantOnboarding.setupFailedDesc': 'Nie można ukończyć konfiguracji sprzedawcy. Proszę spróbować ponownie.',
    'merchantOnboarding.step1.title': 'Informacje o Firmie',
    'merchantOnboarding.step1.subtitle': 'Opowiedz nam o swojej firmie',
    'merchantOnboarding.step1.businessName': 'Nazwa Firmy',
    'merchantOnboarding.step1.businessNamePlaceholder': 'Nazwa Twojej Firmy',
    'merchantOnboarding.step1.businessType': 'Typ Firmy',
    'merchantOnboarding.step1.businessTypePlaceholder': 'Wybierz typ firmy',
    'merchantOnboarding.step1.retail': 'Sklep Detaliczny',
    'merchantOnboarding.step1.restaurant': 'Restauracja',
    'merchantOnboarding.step1.service': 'Dostawca Usług',
    'merchantOnboarding.step1.online': 'Biznes Online',
    'merchantOnboarding.step1.wholesale': 'Hurtownia',
    'merchantOnboarding.step1.other': 'Inne',
    'merchantOnboarding.step1.email': 'Email Firmowy',
    'merchantOnboarding.step1.emailPlaceholder': 'firma@przykład.com',
    'merchantOnboarding.step1.phone': 'Numer Telefonu',
    'merchantOnboarding.step1.phonePlaceholder': '+1 (555) 123-4567',
    'merchantOnboarding.step1.website': 'Strona Internetowa (Opcjonalnie)',
    'merchantOnboarding.step1.websitePlaceholder': 'https://twojafirma.com',
    'merchantOnboarding.step1.logo': 'URL Logo (Opcjonalnie)',
    'merchantOnboarding.step1.logoPlaceholder': 'https://twojafirma.com/logo.png',
    'merchantOnboarding.step1.description': 'Opis Firmy',
    'merchantOnboarding.step1.descriptionPlaceholder': 'Opowiedz klientom, co oferuje Twoja firma...',
    'merchantOnboarding.step2.title': 'Lokalizacja Firmy',
    'merchantOnboarding.step2.subtitle': 'Gdzie znajduje się Twoja firma?',
    'merchantOnboarding.step2.street': 'Adres Ulicy',
    'merchantOnboarding.step2.streetPlaceholder': '123 Główna Ulica',
    'merchantOnboarding.step2.city': 'Miasto',
    'merchantOnboarding.step2.cityPlaceholder': 'Warszawa',
    'merchantOnboarding.step2.state': 'Województwo',
    'merchantOnboarding.step2.statePlaceholder': 'MZ',
    'merchantOnboarding.step2.zip': 'Kod Pocztowy',
    'merchantOnboarding.step2.zipPlaceholder': '00-001',
    'merchantOnboarding.step2.country': 'Kraj',
    'merchantOnboarding.step2.US': 'Stany Zjednoczone',
    'merchantOnboarding.step2.CA': 'Kanada',
    'merchantOnboarding.step2.MX': 'Meksyk',
    'merchantOnboarding.step2.GB': 'Wielka Brytania',
    'merchantOnboarding.step2.addressHint': 'Adres Twojej firmy będzie widoczny dla klientów i używany w wynikach wyszukiwania lokalnego.',
    'merchantOnboarding.step3.title': 'Konfiguracja Płatności',
    'merchantOnboarding.step3.subtitle': 'Połącz swoje konto Stripe, aby akceptować płatności',
    'merchantOnboarding.step3.processingSetup': 'Konfiguracja Przetwarzania Płatności',
    'merchantOnboarding.step3.processingSetupDesc': 'Połącz swoje konto Stripe, aby otrzymywać płatności od klientów (wymagane przez przepisy bankowe)',
    'merchantOnboarding.step3.stripeId': 'ID Konta Procesora Płatności (Stripe Connect)',
    'merchantOnboarding.step3.stripeIdHint': 'Wymagane do otrzymywania środków',
    'merchantOnboarding.step3.stripeIdPlaceholder': 'acct_1234567890',
    'merchantOnboarding.step3.verified': 'Zweryfikowane',
    'merchantOnboarding.step3.verifying': 'Weryfikowanie...',
    'merchantOnboarding.step3.verify': 'Zweryfikuj',
    'merchantOnboarding.step3.whyRequired': 'Dlaczego jest to wymagane?',
    'merchantOnboarding.step3.whyRequiredDesc': 'Przepisy bankowe wymagają zweryfikowanego przetwarzania płatności dla wszystkich sprzedawców.',
    'merchantOnboarding.step3.noAccount': 'Nie masz konta?',
    'merchantOnboarding.step3.createStripe': 'Utwórz konto Stripe Connect',
    'merchantOnboarding.step3.quickActions': 'Szybkie Akcje:',
    'merchantOnboarding.step3.createNewAccount': 'Utwórz Nowe Konto',
    'merchantOnboarding.step3.findMyId': 'Znajdź Moje ID Konta',
    'merchantOnboarding.step3.whereToFindId': 'Gdzie znaleźć Twoje ID:',
    'merchantOnboarding.step3.whereToFindIdDesc': 'Panel Stripe → Ustawienia → Ustawienia Connect → Twoje ID konta zaczyna się od "acct_"',
    'merchantOnboarding.step3.setupComplete': 'Twoje przetwarzanie płatności jest skonfigurowane! Możesz teraz otrzymywać płatności od klientów.',
    'merchantOnboarding.step3.paymentSettings': 'Ustawienia Płatności',
    'merchantOnboarding.step3.acceptOnline': 'Akceptuj Płatności Online',
    'merchantOnboarding.step3.acceptOnlineDesc': 'Pozwól klientom płacić online',
    'merchantOnboarding.step3.acceptInStore': 'Akceptuj Płatności w Sklepie',
    'merchantOnboarding.step3.acceptInStoreDesc': 'Akceptuj płatności w fizycznej lokalizacji',
    'merchantOnboarding.step4.title': 'Wszystko Gotowe!',
    'merchantOnboarding.step4.subtitle': 'Twoje konto sprzedawcy jest gotowe',
    'merchantOnboarding.step4.infoConfigured': 'Informacje o firmie skonfigurowane',
    'merchantOnboarding.step4.locationAdded': 'Lokalizacja dodana',
    'merchantOnboarding.step4.paymentReady': 'Przetwarzanie płatności gotowe',
    'merchantOnboarding.step4.tourTitle': 'Chcesz wycieczkę?',
    'merchantOnboarding.step4.tourDesc': 'Zapoznaj się z narzędziami i funkcjami sprzedawcy',
    'merchantOnboarding.step4.showTour': 'Pokaż mi narzędzia sprzedawcy',
    'merchantOnboarding.step4.tourDuration': '5-minutowa interaktywna wycieczka',
    'merchantOnboarding.step4.tourHint': 'Zawsze możesz uzyskać dostęp do wycieczki później z panelu sprzedawcy.',
    'merchantOnboarding.header': 'Konfiguracja Sprzedawcy',
    'merchantOnboarding.step': 'Krok',
    'merchantOnboarding.back': 'Wstecz',
    'merchantOnboarding.next': 'Dalej',
    'merchantOnboarding.completingSetup': 'Kończenie konfiguracji...',
    'merchantOnboarding.completeSetup': 'Zakończ Konfigurację',
  },
};
